// extracted by mini-css-extract-plugin
module.exports = {"card":"CategoryManager-module__card___3SpSE","table":"CategoryManager-module__table___2z16U"};